import { Pipe, PipeTransform } from '@angular/core';
import { TaxationTypeEnum } from '@zaoblako/shared/modules/catalog/enums/taxation-type.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TaxationTypeEnumDescriptionI18n } from '@zaoblako/shared/modules/catalog/i18n/taxation-type-enum-description.i18n';

@Pipe({
  standalone: true,
  name: 'taxationTypeDescription'
})
export class TaxationTypeDescriptionPipe implements PipeTransform {
  public transform(value: TaxationTypeEnum): string {
    return TaxationTypeEnumDescriptionI18n[I18nLocalesEnum.RU_RU][value];
  }
}
